var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{ref:_vm.theDamnRef,attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.media),function(item){return _c('swiper-slide',{key:item.id,style:(`background: url(${item.url})`)})}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }